import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrandingWatermarkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"branding_watermark"}/>
}
